<template>
  <div :class="{hasError:isError}" style="width: 100%;">
      <div>
          <input ref="myfile" style="display:none;" type="file" accept="application/pdf" @change="uploadPdf($event)" :required="required"/>
          <input type="button" class="button" @click.prevent="$refs.myfile.click" value=" Select File ">
          
          <span v-if="modelValue.FileName" style=" white-space: nowrap;"> {{ modelValue.FileName }}</span>
         



      </div>
  </div>

</template>


<script>
export default {
  props: ["modelValue","disabled", "required", "error"],
  emits: ["update:modelValue","uploaded","update:error"],

  data() {
    return {
      value: null ,
      fileId:'',
      filename:'',
      content:'',
      type:'',
    };
  },
  
  created() {
      this.value = this.modelValue;
      if(this.value && this.value.FileId){
        this.fileId=this.value.FileId;
      }
      
  },
  watch: {
    modelValue: function() {
            console.log('myupload watch 1...................')
            let self=this;
            self.fileId=this.modelValue.FileId;
            self.filename=this.modelValue.FileName;
            self.content=this.modelValue.FileContext;
            self.type=this.modelValue.FileType;
            console.log('myupload watch 2...................')
          }
    },
  mounted(){
    this.$emit("update:error", this.isError);
  },
  computed: {
    isError() {
      return  this.required && !this.filename ;
    },
  },
  methods: {
    uploadPdf(event){
      let self = this;
      let file = event.target.files[0];
      if (file) {

         
              if (file.type != 'application/pdf') {
                event.target.value = '';
                return alert('請選擇PDF格式檔案');
              }

              let fsize = file.size;
              let fsizeK = Math.round((fsize / 1024));
                    // The size of the file.
              if (fsizeK >= 4096) {
                event.target.value = '';
                return alert("File too Big, please select a file less than 4mb");
              }


              self.filename=file.name;
              self.type = file.type;
               let reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function () {
              self.content=reader.result;
                let o={
                  FileId:self.fileId,
                  FileName:self.filename,
                  FileContext:self.content,
                  FileType:self.type,
                }
                self.$emit("update:modelValue",o);
                self.$emit("update:error", this.isError);
                self.$emit("uploaded",o);
                event.target.value = '';
                
              };
              reader.onerror = function () {
               //('Error: ', error);
                self.$emit("update:error", this.isError);
                event.target.value = '';
                
              };

          }
        }
    },
    
  }



</script>
<style scoped>
.hasError label {
  color:red;
  border-color: red;
  border-width: thin;
}
.hasError div{
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>
